var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividualReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#111928"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8388_44884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 11.2986C10.5003 11.2986 9.30029 10.1186 9.30029 8.67859C9.30029 7.23859 10.5003 6.05859 12.0003 6.05859C13.5003 6.05859 14.7003 7.23859 14.7003 8.67859C14.7003 10.1186 13.5003 11.2986 12.0003 11.2986Z",
    fill: "#111928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9403 18.1581H8.06033C7.66033 18.1581 7.34033 17.8381 7.34033 17.4381V15.6381C7.34033 13.6781 8.94033 12.0781 10.9003 12.0781H13.1203C15.0803 12.0781 16.6803 13.6781 16.6803 15.6381V17.4381C16.6603 17.8181 16.3403 18.1581 15.9403 18.1581Z",
    fill: "#111928"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8388_44884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8,
    height: 12.8,
    fill: "white",
    transform: "translate(5.6001 5.69922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualReporting);
export default __webpack_public_path__ + "static/media/individual-reporting.6cf7702f805595c8afd8dc33471d3c66.svg";
export { ForwardRef as ReactComponent };